import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { delay } from 'rxjs/operators';
import { v4 } from 'uuid';
import { DisplayProductDataService } from '../display-product-data.service';
import { checkMaterialName } from '../names.validator';

export class ImmediateErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
    selector: 'app-material-create',
    templateUrl: './material-create.component.html',
    styleUrls: ['./material-create.component.scss'],
    standalone: false
})
export class MaterialCreateComponent implements OnInit {

  materialForm: UntypedFormGroup;
  matcher = new ImmediateErrorStateMatcher();
  constructor(
    private fb: UntypedFormBuilder,
    private snackBar: MatSnackBar,
    private displayProductData: DisplayProductDataService,
    private dialogRef: MatDialogRef<MaterialCreateComponent>
  ) { }

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.materialForm = this.fb.group({
      name: ['', [Validators.required, checkMaterialName.bind(this)]],
    });
  }

  onSubmit(result) {
    result.uuid = v4();

    this.displayProductData.createNewMaterial(result).subscribe(item => {
      this.snackBar
      .open(item, '', { duration: 1500, panelClass: 'hintMsg' })
      .afterDismissed()
      .pipe(delay(0))
      .subscribe(() => this.dialogRef.close(result));
    });
  }

}
